import {TweenLite} from 'gsap'
import GeneralUtils from './GeneralUtils.js'
import axios from 'axios'
function renderStyle (properties) {
  var styleString = ''
  for (var p in properties) {
    // console.log(self.transition)
    // var propValue = self.transition[p] ? self.properties[p] : self.properties[p]
    // console.log(propValue)
    var propertyPrefix = GeneralUtils.isMobile() ? 'm' : ''
    switch (p) {
      case 'left': {
        styleString += 'left:' + properties[propertyPrefix + p] + 'px;'
        break
      }
      case 'top': {
        styleString += 'top:' + properties[propertyPrefix + p] + 'px;'
        break
      }
      case 'width': {
        styleString += 'width:' + properties[propertyPrefix + p] + 'px;'
        break
      }
      case 'height': {
        styleString += 'height:' + properties[propertyPrefix + p] + 'px;'
        break
      }
      case 'font': {
        styleString += 'font-family:' + properties[p] + ';'
        break
      }
      case 'size': {
        var fontSixeVale = properties.mwidth ? properties.mwidth / properties.width : 1
        styleString += 'font-size:' + (properties[p] * fontSixeVale).toString() + 'px;'
        break
      }
      case 'color': {
        styleString += 'color:' + properties[p] + ';'
        break
      }
      case 'lineHeight': {
        styleString += 'line-height:' + properties[p] + 'px;'
        break
      }
      case 'opacity': {
        styleString += 'opacity:' + properties[p] + ';'
        break
      }
      case 'rotation': {
        styleString += 'transform:rotate(' + properties[p] + 'deg);'
        break
      }
    }
  }
  return styleString
}
function initialise (properties, transition, zone) {
  var easingFormula = GeneralUtils.getEasing(transition.easeOption, transition.easeDirection)
  var clonedTrasition = JSON.parse(JSON.stringify(transition))
  var delay = null
  if (zone > -1) {
    // console.log(clonedTrasition)
    delay = transition[Number(zone)].delay !== undefined && transition[Number(zone)].delay !== null ? transition[Number(zone)].delay : 0
    clonedTrasition[Number(zone)].values.delay = delay
    TweenLite.to(properties, transition[Number(zone)].duration, clonedTrasition[Number(zone)].values)
  } else {
    clonedTrasition.values.ease = easingFormula
    delay = transition.delay !== undefined && transition.delay !== null ? transition.delay : 0
    clonedTrasition.values.delay = delay
    TweenLite.to(properties, transition.duration, clonedTrasition.values)
  }
}
function getParameterByName (name, url) {
  if (!url) url = window.location.href
  name = name.replace(/[\[\]]/g, "\\$&")
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}
function generateID () {
  return 'widget_' + Math.random().toString().split('.').join('') + Math.random().toString().split('.').join('') + Math.random().toString().split('.').join('')
}
function inHotZone (index) {
  var threshold = 150
  var winHeight = GeneralUtils.getWindowSize().height
  var sectionTop = winHeight * index
  var scrollPosition = GeneralUtils.getMainScrollElement().scrollTop
  return scrollPosition > sectionTop - threshold && scrollPosition < sectionTop + threshold
}
function getCurrentZone (sectionCount) {
  var zone = 0
  // var threshold = 150
  var winHeight = GeneralUtils.getWindowSize().height
  var scrollPosition = GeneralUtils.getMainScrollElement().scrollTop
  for (var i = 0; i < sectionCount; i++) {
    var sectionTop = winHeight * i
    if (scrollPosition >= sectionTop - (GeneralUtils.getWindowSize().height / 2)) {
      zone = i
    }
  }
  return zone
}
function getPropertyInputType (key) {
  var type = GeneralUtils.InputTypes.NUMBER
  var textKeys = ['color', 'text', 'link', 'post', 'download', 'script', 'extras', 'url', 'modal', 'role', 'alt']
  var enumKeys = GeneralUtils.getKeys(GeneralUtils.EnumMatrix)
  // console.log(GeneralUtils.EnumMatrix)
  for (var i = 0; i < textKeys.length; i++) {
    if (key === textKeys[i]) {
      type = GeneralUtils.InputTypes.TEXT
    }
  }
  for (i = 0; i < enumKeys.length; i++) {
    if (key === enumKeys[i]) {
      type = GeneralUtils.InputTypes.SELECT
    }
  }
  return type
}
function renderLinkWithArgs (lnk) {
  return lnk + document.location.search
}
function modal (url) {
  var mainBody = document.querySelector('body')
  var modalEl = document.createElement('div')
  modalEl.setAttribute('style', 'position:fixed; left: 0; top: 0; right: 0; bottom: 0; background-color: rgba(0,0,0,.8); z-index: 20000;')
  var modalCloser = document.createElement('div')
  modalCloser.setAttribute('style', 'position:absolute; top: 0; left: 0; bottom: 0; right: 0;');
  modalEl.appendChild(modalCloser)
  modalCloser.addEventListener('click', function (e) {
    mainBody.removeChild(modalEl)
  })
  var closeIcon = document.createElement('span')
  closeIcon.innerHTML = '&#10006';
  closeIcon.setAttribute('style', 'display:inline-block; position: absolute; top: 75px; left: 50%; margin-left: 385px; color: #ff0000;')
  modalCloser.appendChild(closeIcon)
  var innerModeal = document.createElement('div')
  innerModeal.setAttribute('style', 'position:relative; width: 800px; height: 550px; margin: 100px auto;')
  var frameEl = document.createElement('iframe')
  frameEl.setAttribute('style', 'width: 100%; height: 100%; border: none;')
  frameEl.setAttribute('src', url)
  modalEl.appendChild(innerModeal)
  innerModeal.appendChild(frameEl)
  mainBody.appendChild(modalEl)
}
function post (url) {
  axios.get(url + document.location.search).then((response) => {
    // console.log(response.data)
    var rData = response.data
    for (var r in rData) {
      switch (r) {
        case PostDirectives.NEW_TAB: {
          var body = document.querySelector('body')
          var anchor = document.createElement('a')
          anchor.setAttribute('href', rData[r])
          anchor.setAttribute('target', 'blank')
          body.appendChild(anchor)
          anchor.click()
          // body.removeChild(anchor)
          break
        }
        case PostDirectives.DOWNLOAD: {
          var body = document.querySelector('body')
          var anchor = document.createElement('a')
          anchor.setAttribute('href', rData[r])
          anchor.setAttribute('download', 'download')
          body.appendChild(anchor)
          anchor.click()
          // body.removeChild(anchor)
          break
        }
        case PostDirectives.REDIRECT: {
          document.location = rData[r]
          break
        }
        case PostDirectives.PRINT: {
          var printContainer = document.querySelector('body')
          var frame = document.createElement('iframe')
          frame.setAttribute('src', rData[r])
          printContainer.appendChild(frame)
          setTimeout(function (_frame) {
            _frame.contentWindow.focus()
            _frame.contentWindow.print()
          }, 500, frame)
          
          break
        }
      }
    }
  })
}
const PostDirectives = {
  NEW_TAB: 'new_tab',
  REDIRECT: 'redorect',
  PRINT: 'print',
  DOWNLOAD: 'download'
}
const WidgetTypes = {
  NONE: 'none',
  TEXT: 'text',
  IMAGE: 'image',
  IFRAME: 'iframe',
  // GUAGE: 'guage',
  // PIE: 'pie',
  // TICKER: 'svg_ticker',
  BLOCK: 'block',
  JS_APP: 'js_app'
}
const WidgetUtils = {
  renderStyle: renderStyle,
  initialise: initialise,
  generateID: generateID,
  inHotZone: inHotZone,
  getCurrentZone: getCurrentZone,
  WidgetTypes: WidgetTypes,
  post: post,
  getPropertyInputType: getPropertyInputType,
  getParameterByName: getParameterByName,
  renderLinkWithArgs: renderLinkWithArgs,
  modal: modal
}
export default WidgetUtils



// WEBPACK FOOTER //
// ./src/components/utils/WidgetUtils.js